import {Grid, Typography} from '@yandex-delivery/blocks'
import {CopyAltIcon} from '@yandex-delivery/blocks/icons'
import clsx from 'clsx'
import React from 'react'

import {classes} from '../PromoBannerButton.classes'
import type {Props} from './CopyButton.types'

// TODO кажется это должен быть обычный Button + Lead + Text
const Base: React.FC<Props> = ({onClick, text}) => (
  <button className={clsx(classes.button, classes.copyButton)} onClick={onClick} type="button">
    <Grid alignItems="center" container justify="center" wrap="nowrap" zeroMinWidth>
      <Grid alignItems="center" item>
        <CopyAltIcon className={classes.copyIcon} data-theme-invert />
      </Grid>
      <Grid alignItems="center" item>
        <Typography thickness="medium" variant="caption1">
          {text}
        </Typography>
      </Grid>
    </Grid>
  </button>
)
export const CopyButton = React.memo(Base)
